// USER ACTION TYPES
export const SET_USER_PROFILE = 'SET_USER_PROFILE';
export const SET_USER_CHANNEL = 'SET_USER_CHANNEL';
export const SET_SALESFORCE_USER = 'SET_SALESFORCE_USER';
export const SET_USER_MEMBER = 'SET_USER_MEMBER';
export const SET_SHOULD_REFRESH_TOKEN = 'SET_SHOULD_REFRESH_TOKEN';

// ACCOUNT ACTION TYPES
export const SET_ACCOUNT_SUPPORT_TEAM = 'SET_ACCOUNT_SUPPORT_TEAM';

// PEOPLE STRUCTURE TYPES
export const SET_SALESFORCE_SQUADS = 'SET_SALESFORCE_SQUADS';
export const SET_SALESFORCE_MEMBERS = 'SET_SALESFORCE_MEMBERS';
export const SET_USER_IS_LEADER = 'SET_USER_IS_LEADER';
export const SET_USER_IS_ADMIN = 'SET_USER_IS_ADMIN';
export const SET_ALL_USERS = 'SET_ALL_USERS';
export const SET_ALL_PROFILES = 'SET_ALL_PROFILES';
export const SET_ALL_ROLES = 'SET_ALL_ROLES';
export const SET_ALL_CHANNELS = 'SET_ALL_CHANNELS';
export const SET_LEADERSHIP_SQUAD = 'SET_LEADERSHIP_SQUAD';
